<template>
  <v-autocomplete
    v-bind:value="value"
    v-on:change="handleChange"
    :items="membersToShow"
    :label="label"
    hide-no-data
    item-text="fullName"
    item-value="id"
    multiple
    outlined
    :disabled="disabled"
    :rules="rules || []"
    :hide-details="hideDetails"
    :menu-props="{ closeOnContentClick: !multiple }"
    :readonly="readonly"
    :placeholder="placeholder"
    ref="autocomplete"
    :dense="dense"
    :search-input.sync="search"
  >
    <template v-slot:selection="data">
      <user-chip
        :user="data.item"
        close
        v-on:close="remove(data.item)"
        v-on:click="remove(data.item)"
        :dense="dense"
        :disabled="disabled"
        :is-manager="onlyManagers"
      ></user-chip>
    </template>
    <template v-slot:item="data">
      <user-chip
        :user="data.item"
        :dense="dense"
        :is-manager="onlyManagers"
      ></user-chip>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MemberAutocomplete",
  components: {},
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    multiple: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    rules: { type: Array },
    label: { type: String, default: "Search by name" },
    directManagerId: { type: String },
    clearOnSelection: { type: Boolean, default: false },
    allowAll: { type: Boolean, default: false },
    memberIdsToNotShow: { type: Array },
    placeholder: { type: String },
    onlyManagers: { type: Boolean, default: false },
    hideDetails: { type: [Boolean, String], default: false },
    dense: { type: Boolean, default: false },
    getter: { type: String, default: "user/search_users" },
    skipGetData: { type: Boolean, default: false }
  },
  data: () => ({
    search: null
  }),
  computed: {
    readonly() {
      if (this.multiple) {
        return false;
      }
      return this.value.filter(x => x != null).length == 1;
    },
    membersToShow() {
      if (this.memberIdsToNotShow && this.memberIdsToNotShow.length) {
        return this.members.filter(
          x => this.memberIdsToNotShow.findIndex(y => y == x.id) < 0
        );
      }
      return this.members;
    },
    members() {
      return this.$store.getters[this.getter];
    },
    ...mapGetters({})
  },
  created() {
    this.getUsers();
  },
  methods: {
    handleChange(e) {
      if (!this.multiple && e.length > 1) {
        e.shift();
      }
      this.$emit(
        "change-full",
        this.$refs.autocomplete.cachedItems.filter(x => e.indexOf(x.id) >= 0)
      );
      this.$emit("change", e);
      this.search = "";
      if (this.clearOnSelection) {
        this.$nextTick(() => {
          this.$emit("change", []);
          this.$refs.autocomplete.lazySearch = "";
        });
      }
    },
    remove(item) {
      let index = this.value.findIndex(cv => cv.id == item.id);
      if (index == -1) {
        index = this.value.findIndex(cv => cv == item.id);
      }
      if (index >= 0) this.value.splice(index, 1);
      this.$emit("change", this.value);
    },
    getUsers() {
      if (this.skipGetData) {
        return;
      }
      this.loading = true;
      let search = {};
      if (this.directManagerId) {
        search.directManagerId = this.directManagerId;
      }
      if (this.allowAll) {
        search.allowAll = this.allowAll;
      }
      if (this.onlyManagers) {
        search.onlyManagers = this.onlyManagers;
      }
      this.$store.dispatch("user/searchUsers", search).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
